module.exports = __webpack_public_path__ + "static/img/group-light.24472a63.png";